import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { FiArrowDown, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import heroImg from '../../assets/hero.jpg';
import styles from './Hero.module.css';

const WHATSAPP = 'https://wa.me/16726676878?text=Hi%20Murat%2C%20I%20would%20like%20to%20book%20an%20oil%20change%20service.';

export default function Hero() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  const opacity = useTransform(scrollYProgress, [0, 0.7], [1, 0]);

  const scrollDown = () => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });

  const chips = [
    t('hero.chips.freeCheckup'),
    t('hero.chips.obd'),
    t('hero.chips.brakeChange'),
    t('hero.chips.brakeInspection'),
    t('hero.chips.fluidCheck'),
  ];

  return (
    <section id="home" className={styles.hero} ref={ref}>
      <motion.div className={styles.imgWrap} style={{ y }}>
        <img src={heroImg} alt="Mobile oil change" className={styles.bg} />
        <div className={styles.overlay} />
      </motion.div>

      <motion.div className={styles.content} style={{ opacity }}>
        <motion.div className={styles.badge}
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
          {t('hero.badge')}
        </motion.div>

        <motion.h1 className={styles.headline}
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}>
          {t('hero.headline1')}<br />
          <span className={styles.accent}>{t('hero.headline2')}</span><br />
          {t('hero.headline3')}
        </motion.h1>

        <motion.p className={styles.sub}
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
          {t('hero.sub')}
        </motion.p>

        <motion.div className={styles.btns}
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.65 }}>
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className={styles.btnWa}>
            <FaWhatsapp size={20}/> {t('hero.bookWhatsapp')}
          </a>
          <a href="tel:+16726676878" className={styles.btnPhone}>
            <FiPhone size={18}/> 672-667-6878
          </a>
        </motion.div>

        <motion.div className={styles.chips}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }}>
          {chips.map(c => (
            <span key={c} className={styles.chip}>{c}</span>
          ))}
        </motion.div>
      </motion.div>

      <button className={styles.scrollBtn} onClick={scrollDown} aria-label="Scroll down">
        <motion.div animate={{ y: [0, 6, 0] }} transition={{ repeat: Infinity, duration: 1.6 }}>
          <FiArrowDown size={22} color="#fff"/>
        </motion.div>
      </button>
    </section>
  );
}
